var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { BackgroundProvider } from '../BackgroundContext/index.js';
import { TableHeader, TableHeaderCell } from './TableHeader.js';
import { TableCell, TableRow } from './TableRow.js';
export const Table = (props) => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (React.createElement(BackgroundProvider, { backgroundType: "surface" },
        React.createElement("div", { className: "flex flex-col" },
            React.createElement("div", { className: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" },
                React.createElement("div", { className: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" },
                    React.createElement("div", { className: "shadow overflow-hidden border-b border-surface-200/50 sm:rounded-lg" },
                        React.createElement("table", Object.assign({ className: clsx('min-w-full divide-y divide-surface-200/50', className) }, rest), children)))))));
};
const TableBody = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (React.createElement("tbody", Object.assign({ className: clsx('divide-y divide-surface-200/50', 'bg-surface-50 text-basicSurface-500', className) }, rest), children));
};
Table.Header = TableHeader;
Table.HeaderCell = TableHeaderCell;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
//# sourceMappingURL=Table.js.map